import React from 'react';
import { IOrder } from '../../../types';
import { maxProcessingMinutes } from '../../../helpers/general.helpers';

export const OrderFlag = ({ order }: { order: IOrder }) => {
  const [now, setNow] = React.useState(Date.now);
  const startTime = order.scheduledTime ? order.timePlaced : order.timePaid;
  const startedAt = startTime ? new Date(startTime).getTime() : NaN;
  const isActive =
    Boolean(order.timePaid) &&
    Number.isFinite(startedAt) &&
    !['DELIVERED', 'CANCELED', 'SCHEDULED'].includes(order.status ?? '');

  React.useEffect(() => {
    if (!isActive) return;
    setNow(Date.now());
    const intervalId = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(intervalId);
  }, [isActive, startedAt]);

  if (!isActive) return <span className="text-[12px] text-neutral-500">-</span>;

  const remaining = Math.ceil(
    (startedAt + maxProcessingMinutes(order) * 60_000 - now) / 1000
  );
  const overdue = remaining < 0;
  const seconds = Math.abs(remaining);
  const totalMinutes = Math.floor(seconds / 60);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  const parts = [];
  if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  if (days > 0 || hours > 0) {
    parts.push(`${hours} ${hours === 1 ? 'hr' : 'hrs'}`);
  }
  parts.push(`${minutes} ${minutes === 1 ? 'min' : 'mins'}`);
  const duration =
    seconds > 0 && totalMinutes === 0 ? '<1 min' : parts.join(' : ');
  const formatted = `${overdue ? '-' : ''}${duration}`;

  return (
    <span
      className={`text-[12px] whitespace-nowrap tabular-nums ${
        overdue ? 'text-red-600' : ''
      }`}
      title={
        overdue ? 'Time past fulfilment cutoff' : 'Time until fulfilment cutoff'
      }
    >
      {formatted}
    </span>
  );
};
